import React from "react";
import {
  IconChevronDown,
  IconChevronUp,
  IconMedicalCross,
  IconStethoscope,
  IconUser,
} from "@tabler/icons-react";
import styles from "./MAccordionHeader.module.css";

interface MAccordionHeaderProps {
  title: string;
  isOpen: boolean;
  onClick: () => void;
  className?: string;
  titleColor?: string;
  variant?: "default" | "contact";
}

export const MAccordionHeader: React.FC<MAccordionHeaderProps> = ({
  title,
  isOpen,
  onClick,
  className = "",
  titleColor,
  variant = "default",
}) => {
  const getLeftIcon = () => {
    if (variant === "contact") {
      if (
        title.toLowerCase().includes("contact details") ||
        title.toLowerCase().includes("yourcontactdetails")
      )
        return <IconUser size={16} color="#45168C" />;
      if (title.toLowerCase().includes("emergency"))
        return <IconMedicalCross size={16} color="#45168C" />;
      if (
        title.toLowerCase().includes("doctor") ||
        title.toLowerCase().includes("vet")
      )
        return <IconStethoscope size={16} color="#45168C" />;
    }
    return null;
  };

  return (
    <div
      className={`${styles.accordionHeader} ${
        variant === "contact" ? styles.contactVariant : ""
      } ${variant === "contact" && isOpen ? styles.open : ""} ${className}`}
      onClick={onClick}
    >
      {variant === "contact" && (
        <div className={styles.iconContainer}>{getLeftIcon()}</div>
      )}
      <span
        className={styles.title}
        style={titleColor ? { color: titleColor } : undefined}
      >
        {title}
      </span>
      {variant === "contact" &&
        (isOpen ? (
          <IconChevronUp size={16} className={styles.chevronIcon} />
        ) : (
          <IconChevronDown size={16} className={styles.chevronIcon} />
        ))}
      {variant !== "contact" && (
        <IconChevronDown
          size={16}
          className={`${styles.icon} ${
            isOpen ? styles.iconOpen : styles.iconClosed
          }`}
        />
      )}
    </div>
  );
};

export default MAccordionHeader;
